import { render, staticRenderFns } from "./invoiceTable.vue?vue&type=template&id=b4cd8302&scoped=true&"
import script from "./invoiceTable.vue?vue&type=script&lang=js&"
export * from "./invoiceTable.vue?vue&type=script&lang=js&"
import style0 from "./invoiceTable.vue?vue&type=style&index=0&id=b4cd8302&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cd8302",
  null
  
)

export default component.exports